<template>
  <main class="centerBox">
    <section class="whiteBox">
      <div class="row logo">
        <img
          src="@/assets/images/logo.png"
          alt="logo"
        >
      </div>
      <div class="content">
        <h1>{{$t('login.title')}}</h1>
      </div>
      <hr>
      <form @submit.prevent="logIn">
        <div class="content">
          <div class="column">
            <p
              class="errorFullLine"
              v-if="invalidLogin"
            >{{$t('error.emailOrPasswordInvalid')}}</p>
            <br>
            <div class="row spaceBetween">
              <label>{{$t('login.email')}}</label>
              <p
                class="errorSentence"
                v-if="!emailFormat && isSubmitted"
              >{{$t('error.wrongEmailFormat')}}</p>
            </div>
            <input
              type="email"
              :class="{ 'error' : !emailFormat && isSubmitted }"
              v-model="email"
            >
            <div class="row spaceBetween">
              <label>{{$t('login.password')}}</label>
              <p
                class="errorSentence"
                v-if="!passwordFormat && isSubmitted"
              >{{$t('error.wrongPassword')}}</p>
            </div>
            <div class="row alignCenter">
              <div class="rowIn ">
                <input
                  :type="inputClass"
                  :class="{ 'error' : !passwordFormat && isSubmitted }"
                  v-model="password"
                >
                <span
                  @mousedown="displayPassword"
                  @mouseup="hidePassword"
                  @mouseleave="hidePassword"
                  :class="toggleClass"
                ></span>
              </div>
            </div>
            <div class="spacer-10"></div>
            <router-link :to="{name: 'forgotPassword'}">{{$t('login.passwordForgotten')}}</router-link>
          </div>
        </div>
        <hr>
        <div class="content">
          <button @click="logIn">{{$t('button.login')}}</button>
        </div>
      </form>
    </section>
  </main>
</template>

<script>
import isEmail from "validator/lib/isEmail";
import Users from "@/services/Users";
import Login from "@/services/Login";
import cookie from "vue-cookie";
import passwordManagement from "@/mixins/passwordManagement";

export default {
  mixins: [passwordManagement],
  data() {
    return {
      isSubmitted: false,
      invalidLogin: false,
      email: "",
      password: ""
    };
  },
  computed: {
    emailFormat: function() {
      return isEmail(this.email);
    },
    passwordFormat: function() { return this.checkPassword(this.password)}
  },
  methods: {
    logIn() {
      this.isSubmitted = true;
      if (this.emailFormat && this.password) {
        let user = {
          login: this.email,
          password: this.password
        };
        Login.getToken(user).then(
          res => {
            //si ok
            if (res.status == 200) {
              this.invalidLogin = false;
              //save data in cookie
              cookie.set("mgc-authToken", res.data["token"], {
                expires: "12h"
              });
              cookie.set("mgc-u-id", res.data["user-id"], { expires: "12h" });
              //store date in Vuex
              this.storeUser(res.data["user-id"]);
            }
          },
          () => {
            this.invalidLogin = true;
          }
        );
      }
    },
    getProfile(id, cb) {
      Users.getProfile(id).then(res => {
        cb(res.data);
      });
    },
    storeUser(id) {
      Users.getUserById(id).then(res => {
        this.$store.commit(
          "STORE_NAME",
          res.data["first-name"] + " " + res.data["name"]
        );
        this.getProfile(res.data["user-profile-id"], cb => {
          this.$store.commit("LOG_IN");
          this.$store.commit("STORE_USERPROFILE", cb);
          this.$router.push("/");
        });
      });
    }
  }
};
</script>

<style scoped>
.logo {
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  padding-bottom: 10%;
}
.field-icon {
  margin-left: -25px;
  z-index: 2;
}
.blue {
  color: #2e75d0;
}
.demiRowIn {
  display: "inline-flex";
  width: 50%;
  margin: 5px 0px;
}
.rowIn {
  display: "inline-flex";
  width: 100%;
  margin: 5px 0px;
}
</style>